import React from 'react';
import NewSessionContextProvider from '../NewSessionContext/NewSessionContextProvider';

export default function SessionContextProvider({ children }: { children: React.ReactNode }) {
  return <NewSessionContextProvider>{children}</NewSessionContextProvider>;
}
